import * as _ from 'lodash';

import IZone = ZoneIQCalibration.IZone;

export class ZoneModel implements IZone {
    public Id: number;
    public RevisionId: number;
    public Name: string;
    public Alias: string;
    public BaseZoneId: number = null;
    public ZoningCodeId: number;
    public CloneId: number;
    public CreatedOn: Date;
    public ModifiedOn: Date;

    constructor(data: IZone) {
        Object.assign(
            this,
            _.pick(data, ['Id', 'RevisionId', 'Name', 'Alias', 'BaseZoneId', 'ZoningCodeId', 'CloneId'])
        );
        this.CreatedOn = new Date(data.CreatedOn);
        this.ModifiedOn = new Date(data.ModifiedOn);
    }

    static factory(data: IZone) {
        return new ZoneModel(data);
    }
}
